import { Component, OnInit } from '@angular/core';
import { LocalStorage } from 'src/app/core/localstorage';
import { TokenService } from 'src/app/core/services/token.service';
import { NbDialogService } from '@nebular/theme';
import { HostSelectionDialogComponent } from '../host-selection-dialog/host-selection-dialog.component';

@Component({
    selector: 'app-dev-toolbar',
    templateUrl: './dev-toolbar.component.html',
    styleUrls: ['./dev-toolbar.component.scss'],
})
export class DevToolbarComponent implements OnInit {
    host: string;
    constructor(
        public tokenService: TokenService,
        private localStorage: LocalStorage,
        private dialogService: NbDialogService
    ) {
        this.host = tokenService.host;
    }

    ngOnInit(): void {}

    openHostDialog() {
        const dialogRef = this.dialogService.open(HostSelectionDialogComponent, {
            context: {
                availableHosts: this.tokenService.availableHosts,
                currentHost: this.host,
            },
        });

        dialogRef.onClose.subscribe((selectedHost: string) => {
            if (selectedHost) {
                this.host = selectedHost;
                this.changeHost();
            }
        });
    }

    async changeHost() {
        this.tokenService.host = this.host;
        this.localStorage.resetLangs();
        this.localStorage.resetToken();
        const response: any = await this.tokenService.refreshToken().toPromise();
        if (response.status_code === 0) {
            window.location.href = window.location.origin;
        }
    }
}
